module.exports = __webpack_public_path__ + "img/PT.352ff4b0.svg";